import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";

export const StyledLoading = styled(Loading)`
  margin-block: 20px;
  margin-inline: 0;
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin-block-start: 16px;
  padding: 12px;

  border-radius: 20px;

  background-color: #f8f8f8;

  ${theme.breakpoints.up("tablet")} {
    gap: 24px;

    margin-block-start: 32px;
    padding: 20px;

    border-radius: 20px;
  }
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
`;
